<div class="filter-container">
  <div class="search-wrapper">
    <input 
      type="text" 
      [(ngModel)]="searchText" 
      (ngModelChange)="onSearchTextChange()" 
      placeholder="コントロールIDで検索"
      class="search-input"
    >
    <button 
      class="filter-toggle-button" 
      (click)="toggleFilterVisibility()" 
      [class.active]="showFilter"
      title="フィルターを表示/非表示"
    >
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>

  <div 
    class="filter-panel" 
    [class.visible]="showFilter" 
    (click)="$event.stopPropagation()"
  >
    <div class="filter-content">
      <div class="filter-sections-wrapper">
        <div class="filter-section">
          <h3>サービス</h3>
          <div class="checkbox-group">
            <label *ngFor="let service of uniqueServices">
              <input type="checkbox" 
                     [checked]="selectedServices[service]" 
                     (change)="toggleServiceSelection(service)">
              {{ service }}
            </label>
          </div>
        </div>

      <div class="filter-section">
        <h3>ステータス</h3>
        <div class="checkbox-group">
          <label *ngFor="let status of ['申請済み', '未完了', '完了']">
            <input type="checkbox" 
                   [checked]="selectedStatuses[status]" 
                   (change)="toggleStatusSelection(status)">
            {{ status }}
          </label>
        </div>
      </div>

      <button 
        class="reset-button" 
        (click)="clearAllFilters()" 
        title="フィルターをリセット"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</div>